export default "__VITE_PUBLIC_ASSET__85792103__"